import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { FiLogOut } from 'react-icons/fi';
import styleSideBar from './styles';
import ListItemSideBar from './Components/ListItemSidebar';
import { useLocation } from 'react-router-dom';
import './styles/styles.css';
import { theme } from '../../styles/theme';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import AvailableBalance from './Components/AvailableBalance';
const useStyles = makeStyles((theme) => styleSideBar(theme));

const { rbmWhite, secondaryColor } = theme.colors;
export default function Sidebar() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  function handleClick(link) {
    navigate(link);
  }

  const logout = () => {
    Swal.fire({
      title: 'Deseja mesmo sair?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: { secondaryColor },
      cancelButtonColor: { rbmWhite },
      confirmButtonText: 'Sair',
      cancelButtonText: 'Voltar',
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/login');
        localStorage.removeItem('is_authenticate');
      }
    });
  };

  useEffect(() => {
    handleDrawerClose();
  }, [location]);

  return (
    <div className={pathname === '/login' ? classes.hidden : classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.logo}>
            <div
              className="imagemLogo"
              onClick={() => handleClick('/dashboard')}
            ></div>
          </div>
          <AvailableBalance />
          <div className={classes.barIconsContainer}>
            <FiLogOut
              className={classes.barIcons}
              title="Sair"
              onClick={() => logout()}
            />
          </div>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {open ? (
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon className={classes.icons} />
            </IconButton>
          ) : (
            <IconButton onClick={handleDrawerOpen}>
              <MenuIcon className={(classes.icons, classes.mainIcon)} />
            </IconButton>
          )}
        </div>

        <ListItemSideBar classes={classes}></ListItemSideBar>
      </Drawer>
    </div>
  );
}
